import { react2angular } from 'react2angular';
import {MainFooter} from "./MainFooter";

angular.module('webtip.module')
  .component('mainFooter', react2angular(MainFooter,[],['userService', 'eventService', '__env']));
